import { Space, Text } from "@/atoms"
import { ArrowRightOutlined } from "@/icons"
import { Item, List } from "@/pages/DiscoveryPage/components/molecules/List"
import { CopyFixCommandButton } from "./CopyFixCommandButton"

import styles from "./SourceList.module.scss"

import { useTranslation } from "@/hooks/useTranslation"
import type { Remedies } from "."

export const RemediationItem = ({
  remedies,
  introducedThrough,
  noLimits
}: Remedies) => {
  const { t } = useTranslation()
  const classes = { value: styles.fixValue, item: styles.fixItem }

  return (
    <List
      classes={{
        list: styles.itemList,
        button: styles.button
      }}
      items={remedies}
      limit={noLimits ? undefined : 2}
      render={({
        name,
        version,
        remove,
        reinstall,
        fixType,
        currentVersion,
        fixCommand
      }) => {
        if (remove) {
          return (
            <Item
              wrap
              classes={classes}
              title={name}
              value={`(${t("inventory.codeRepositoriesTab.drawer.issue.nestedRow.remove")})`}
            />
          )
        }

        let currentVersionValue = currentVersion
        if (!currentVersion) {
          if (reinstall) {
            currentVersionValue = version
          } else {
            currentVersionValue =
              introducedThrough.find(
                (packageRecord) => packageRecord?.[0]?.name === name
              )?.[0]?.version || ""
          }
        }
        const knownFixType =
          fixType === "patch" || fixType === "minor" || fixType === "major"
        let fixTypeText = ""
        if (knownFixType) {
          fixTypeText = `${t(`general.${fixType}Update`)}: `
        } else if (reinstall) {
          fixTypeText = `${t("general.reinstall")}: `
        }

        const nameVersionText = `${name}${currentVersionValue ? `:${currentVersionValue}` : ""}`

        // Used for copy fix
        if (noLimits) {
          const newVersionText = reinstall ? "" : ` -> ${version}`

          return (
            <Item title={`${fixTypeText}${nameVersionText}${newVersionText}`} />
          )
        }

        const copyFixCommandComponent = (
          <CopyFixCommandButton
            t={t}
            key={name}
            fixCommand={fixCommand}
            noLimits={noLimits}
          />
        )

        if (reinstall) {
          return (
            <Item
              wrap
              classes={classes}
              title={
                <Space size={4} baseline inline>
                  <Text className={styles.fixTitleFixType}>
                    {t("general.reinstall")}:
                  </Text>
                  <Text className={styles.fixTitleCurrentValue}>{name}</Text>
                </Space>
              }
              value={currentVersionValue}
              suffix={copyFixCommandComponent}
            />
          )
        }

        return (
          <Item
            wrap
            classes={classes}
            title={
              <Space inline size={4}>
                <Space baseline inline size={4}>
                  {knownFixType && (
                    <Text className={styles.fixTitleFixType}>
                      {t(`general.${fixType}Update`)}:
                    </Text>
                  )}
                  <Text className={styles.fixTitleCurrentValue}>
                    {nameVersionText}
                  </Text>
                </Space>
                <ArrowRightOutlined className={styles.fixTitleArrow} />
              </Space>
            }
            value={version}
            suffix={copyFixCommandComponent}
          />
        )
      }}
    />
  )
}
